function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M256 512C115 512 0 399 0 261c0-72 31-140 86-188 15-13 38-12 52 3 13 15 12 38-3 51-39 34-62 83-62 134 0 99 82 179 183 179s183-80 183-179c0-51-23-100-61-134-16-13-17-36-4-51 14-15 37-16 52-3 55 48 86 116 86 188 0 138-115 251-256 251zm40-279V39c0-22-18-39-41-39-22 0-41 17-41 39v194c0 22 19 39 41 39 23 0 41-17 41-39z"
})));